import React from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

import Form from '../../../../../../components/Form/Form/';
import Spinner from '../../../../../../components/Spinner';

// Input Components List
import RadioInput from './inputs/radio';
import SliderSelectInput from './inputs/slider-select';
import MultiSelect from './inputs/multi-select';
import './ComponentWrapper.scss';

const ComponentModuleData = gql`
  query($ModuleComponentID: Int!) {
    ModuleComponentInstance(id: $ModuleComponentID) {
      module_instance {
        scheduled_to
        advisor {
          id
          first_name
          last_name
          photo
        }
        student {
          id
          first_name
          last_name
          photo
        }
        Industry {
          name
        }
      }
      user_id
      module_component {
        id
        module_component_name
        module_component_description
        groups {
          name
          html_content
          order
          fields {
            id
            type
            label
            description
            field_answers {
              id
              value
            }
            field_options {
              id
              option_value
              sequence
            }
            field_group {
              id
              field_id
              active
              order
              required
            }
            fields_display_rules {
              id
              hidden_field_id
              controlling_field_id
              controlling_field_option_id
              show1_hide0
            }
          }
        }
        module {
          module_name
        }
      }
    }
  }
`;

const UpsertFieldAnswerMutation = gql`
  mutation($ID: Int!, $Fields: [ComponentFieldInput]) {
    upsertFieldAnswers(ComponentInstanceID: $ID, Fields: $Fields) {
      field_id
      value
      updated_at
    }
  }
`;

class ComponentWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentValues: {},
      defaultValue: {},
      missingFields: [],
      loading: false,
      submitted: false,
      multiCheckValue:""
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleFormSubmission = this.handleFormSubmission.bind(this);
    this.saveFormData = this.saveFormData.bind(this);
  }

  handleChange(event) {
    this.setState({
      currentValues: event.target.value,
    });
  }

  saveFormData(FieldAnswers) {
    const FieldData = Object.keys(FieldAnswers).map(FieldID => ({
      id: FieldID,
      value: FieldAnswers[FieldID],
    }));

    return this.props.UpsertFieldAnswer({
      variables: {
        ID: this.props.routeParams.id,
        Fields: FieldData,
      },
    });
  }

  validateForm() {
    console.log(
      this.props.ComponentData.ModuleComponentInstance.module_component,
    );
    const Fields = this.props.ComponentData.ModuleComponentInstance.module_component.groups.reduce(
      (sum, value) => {
        if (value.fields.length > 0) {
          return [...sum, ...value.fields];
        }
        return sum;
      },
      [],
    );

    const MissingFields = Fields.map(Field => {
      if (Field.field_group.required === 1) {
        const ConditionalShow = Field.fields_display_rules.map(Rule => {
          const TargetField = Fields.find(
            field => field.id === Rule.controlling_field_id,
          );

          if (typeof TargetField !== 'undefined') {
            const GoalValue = TargetField['field_options'].find(
              option => option.id === Rule.controlling_field_option_id,
            );
            if (typeof GoalValue !== 'undefined') {
              if (
                Object.prototype.hasOwnProperty.call(
                  this.state.currentValues,
                  Rule.controlling_field_id,
                )
              ) {
                if (
                  this.state.currentValues[Rule.controlling_field_id] ===
                  GoalValue.option_value
                ) {
                  return Rule.show1_hide0 === 1;
                }
              }
              return Rule.show1_hide0 !== 1; // Only show if the value is true which it isn't
            }
          }

          return true;
        });

        if (ConditionalShow.length > 0) {
          if (ConditionalShow.every(x => x === false)) {
            return true;
          }
        }

        if (
          Object.prototype.hasOwnProperty.call(
            this.state.currentValues,
            Field.id,
          )
        ) {
          if (this.state.currentValues[Field.id].trim() !== '') {
            return true;
          }
        }

        return Field;
      }
      return true;
    }).filter(x => x !== true);

    return MissingFields.length === 0 ? true : MissingFields;
  }

  handleFormSubmission() {
    this.setState({
      loading: true,
    });

    const FormValidState = this.validateForm();
    if (FormValidState !== true) {
      this.setState({
        missingFields: FormValidState.map(x => x.id),
        loading: false,
      });
      return null;
    }
    
    this.saveFormData(this.state.currentValues).then(Finished =>
      this.setState({
        loading: false,
        submitted: true,
      }));    
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.authenticatedID !== null) {
      if (nextProps.ComponentData.loading === false) {
        if (typeof nextProps.ComponentData.error === 'undefined') {
          console.log(
            nextProps.ComponentData.ModuleComponentInstance.module_component,
          );
          let Groups =
            nextProps.ComponentData.ModuleComponentInstance.module_component
              .groups;

          console.log('Groups: ', Groups);

          const Answers = Groups.reduce((sum, value) => {
            return [...sum, ...value.fields];
          }, [])
            .map(Field => {
              if (Field.field_answers.length > 0) {
                return {
                  id: Field.id,
                  value: Field.field_answers[0].value,
                };
              }
              return null;
            })
            .reduce((sum, fieldAnswer) => {
              if (fieldAnswer !== null) {
                let NewObject = {};
                NewObject[fieldAnswer.id] = fieldAnswer.value;
                return Object.assign({}, sum, NewObject);
              }
              return sum;
            }, {});

          this.setState({
            defaultValue: Answers,
            currentValues: Answers,
            multiCheckValue: Answers[874]
          });
        }
      }
    }
  }

  getQuestionInput(field) {
    switch (field.type) {
      case 'textarea':
        return <textarea name={field.id} className="Form__Input" />;

      case 'textbox':
        return <input name={field.id} type="text" className="Form__Input" />;

      case 'radio':
        return <RadioInput name={field.id} field={field} />;

      case 'slider-select': {
        return <SliderSelectInput name={field.id} field={field} />;
      }

      case 'select': {
        return (
          <select className="Form__Input" name={field.id}>
            <option>Select</option>
            {field.field_options.map(option => (
              <option key={option.id} value={option.option_value}>{option.option_value}</option>
            ))}
          </select>
        );
      }
  
      case 'multiselect': {
        return <MultiSelect name={field.id} field={field}/>;
      }

      default:
        console.log('Unknown type: ', field.type);
        return null;
    }
  }

  renderQuestions(fields) {
    return fields.map(field => {
      if (field.field_group.active !== 1) {
        return null;
      }

      const ConditionalShow = field.fields_display_rules.map(Rule => {
        const TargetField = fields.find(
          field => field.id === Rule.controlling_field_id,
        );
        if (typeof TargetField !== 'undefined' && TargetField !== null) {
          if (
            Object.prototype.hasOwnProperty.call(TargetField, 'field_options')
          ) {
            const GoalValue = TargetField['field_options'].find(
              option => option.id === Rule.controlling_field_option_id,
            );
            if (typeof GoalValue !== 'undefined') {
              if (
                Object.prototype.hasOwnProperty.call(
                  this.state.currentValues,
                  Rule.controlling_field_id,
                )
              ) {
                if (
                  this.state.currentValues[Rule.controlling_field_id] ===
                  GoalValue.option_value
                ) {
                  return Rule.show1_hide0 === 1;
                }
              }
              return Rule.show1_hide0 !== 1; // Only show if the value is true which it isn't
            }
          }
        }

        return true;
      });

      if (ConditionalShow.length > 0) {
        if (ConditionalShow.every(x => x === false)) {
          return null;
        }
      }

      return (
        <div className="Question__Wrapper" key={'Question_' + field.id}>
          <h4 className="Question__Label">
            {field.label}
            {field.field_group.required === 1 && (
              <span style={{ color: 'red' }}> *</span>
            )}
          </h4>
          {this.state.missingFields.includes(field.id) ? (
            <span style={{ color: '#ee4343' }} className="error-text">
              Field is required
            </span>
          ) : null}
          <p className="Question__Description">{field.description}</p>
          {this.getQuestionInput(field)}
        </div>
      );
    });
  }

  sortQuestion(Questions) {
    let Data = [...Questions];
    Data.sort(function(a, b) {
      if (a.field_group.order - b.field_group.order !== 0) {
        return a.field_group.order - b.field_group.order;
      }
      return a.id - b.id;
    });
    return Data;
  }

  render() {
    if (this.props.authenticatedID !== null) {
      if (this.props.ComponentData.loading === false) {
        if (typeof this.props.ComponentData.error === 'undefined') {
          const Instance = this.props.ComponentData.ModuleComponentInstance
            .module_instance;

          if (
            this.props.authenticatedID ===
            this.props.ComponentData.ModuleComponentInstance.user_id
          ) {
            const ModuleComponent = this.props.ComponentData
              .ModuleComponentInstance.module_component;
            const ModuleInstance = this.props.ComponentData
              .ModuleComponentInstance.module_instance;
            let Groups = [...ModuleComponent.groups];

            Groups.sort(function(a, b) {
              if (a.order - b.order !== 0) {
                return a.order - b.order;
              }
              return a.id - b.id;
            });

            const Fields = Groups.reduce((sum, value) => {
              return [...sum, ...this.sortQuestion(value.fields)];
            }, []);

            const CounterPart = () => {
              let CounterPart = ModuleInstance.student;
              let isAdvisor = true;

              if (this.props.authenticatedID === ModuleInstance.student.id) {
                // Person Viewing is an Student
                isAdvisor = false;
                CounterPart = ModuleInstance.advisor;
              }

              return (
                <div className="IdentityWrapper">
                  <div className="row">
                    <div className="col">
                      <div className="IdentityWrapper__ImageWrapper">
                        {CounterPart && CounterPart.photo !== null ? (
                          <img
                            src={
                              IMAGECACHELINK +
                              '/' +
                              IMAGESTAGE +
                              '/125x125/' +
                              CounterPart.photo
                            }
                          />
                        ) : null}
                      </div>
                    </div>
                    <div className="col">
                      <p>
                        <b>{isAdvisor ? 'Student: ' : 'Advisor: '}</b>
                        {CounterPart
                          ? CounterPart.first_name + ' ' + CounterPart.last_name
                          : null}
                      </p>
                      {ModuleInstance.scheduled_to !== null ? (
                        <div>
                          <b>Scheduled: </b>
                          <p>
                            {new Date(
                              ModuleInstance.scheduled_to,
                            ).toLocaleString()}
                          </p>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              );
            };

            const ExecuteHTMLScripts = HTML => {
              const Scripts = /<script[^>]*>([\s\S]*)?<\/script>/gi.exec(HTML);

              setTimeout(() => {
                if (Scripts) {
                  window.eval(Scripts[1]);
                }
              }, 0);
            };

            return (
              <div className="container">
                <div className="ModuleComponet__Wrapper">
                  <div className="ModuleComponent__Segment">
                    <div className="row">
                      <div className="col">
                        <h1 className="ModuleComponet__Header">
                          {ModuleComponent.module_component_name}
                        </h1>
                        <h3 className="ModuleComponet__SubHeader">
                          {ModuleComponent.module.module_name +
                            (ModuleInstance.Industry !== null
                              ? ' - ' + ModuleInstance.Industry.name
                              : '')}
                        </h3>
                        <p className="ModuleComponet__Description">
                          {ModuleComponent.module_component_description}
                        </p>
                      </div>
                      <div className="col">{CounterPart()}</div>
                    </div>
                  </div>
                  {ModuleComponent.groups.length === 0 ||
                  ModuleComponent.groups[0]['html_content'] === null ? null : (
                    <div
                      className="ModuleComponent__Segment"
                      id=""
                      style={{ paddingTop: '20px' }}
                    >
                      <div className="row">
                        {/* If retool no longer needs to be embedded add DomPurify to this */}
                        {ExecuteHTMLScripts(
                          (ModuleComponent.groups[0] || { html_content: '' })[
                            'html_content'
                          ],
                        )}
                        <div
                          className="col"
                          dangerouslySetInnerHTML={{
                            __html: ModuleComponent.groups[0]['html_content'],
                          }}
                        />
                      </div>
                    </div>
                  )}
                  {this.state.submitted === false ? (
                    Fields.length === 0 ? null : (
                      <div className="ModuleComponent__QuestionWrapper">
                        <h4 className="Question__WrapperTitle">Questions: </h4>
                        <Form
                          onChange={this.handleChange}
                          defaultValue={this.state.defaultValue}
                        >
                          {this.renderQuestions(Fields)}
                          <div className="clearfix">
                            <span
                              onClick={this.handleFormSubmission}
                              className="Button__Submit"
                            >
                              {this.state.loading ? (
                                <Spinner className="spinner--white" />
                              ) : (
                                'Save'
                              )}
                            </span>
                          </div>
                        </Form>
                      </div>
                    )
                  ) : (
                    <h5 style={{ padding: '40px 0' }}>
                      Submitted successfully
                    </h5>
                  )}
                </div>
              </div>
            );
          }
        }
        return (
          <p style={{ textAlign: 'center', marginTop: '30px' }}>
            You cannot view this Component
          </p>
        );
      }
    }
    return <Spinner style={{ marginTop: '30px' }} />;
  }
}

export default compose(
  graphql(ComponentModuleData, {
    name: 'ComponentData',
    options: props => ({
      fetchPolicy: 'network-only',
      variables: {
        ModuleComponentID: props.routeParams.id,
      },
    }),
  }),
  graphql(UpsertFieldAnswerMutation, {
    name: 'UpsertFieldAnswer',
  }),
)(ComponentWrapper);



// WEBPACK FOOTER //
// ./src/routes/modules/routes/ViewComponent/components/ComponentWrapper/index.js